import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import CenterCenterVerticalContainer from "../../components/layout/CenterCenterVerticalContainer";
import MainPageComponent from "../../components/page/MainPageComponent";
import usePayment from "../../hooks/user/usePayment";

function UserPaymentsCreateView(props) {
    let breadcrumbPath = [
        { value: 'Inicio', href: '/' },
        { value: 'Usuario', href: '/user' },
        { value: 'Medios de pago', href: '/user/payments' },
        { value: 'Crear', href: '' }
    ];

    const paymentHk = usePayment();
    const { id } = useParams();

    const [payment, setPayment] = useState({
        name: "",
        description: "",
        sys_protected: false,
        active: true
    });

    useEffect(() => {
        const fetchAsync = async (id) => {
            let payment = await fetchPaymentMethod(id);
            setPayment(payment);
        };
        if (isEditAction()) {
            fetchAsync(id);
        }
    }, []);

    const fetchPaymentMethod = async (id) => {
        return await paymentHk.readId(id);
    };

    const onSubmitForm = async (event) => {
        event.preventDefault();
        if (isEditAction()) {
            editPaymentRequest();
        }
        else {
            createPaymentRequest();
        }
    };

    const isEditAction = () => {
        let isEdit = id !== undefined
        return isEdit;
    };

    const createPaymentRequest = async () => {
        const result = await paymentHk.create(payment);
        if (result) {
            clearInputs();
            alert("Created");
        }
        else {
            //TODO: alert
            alert("Failed");
        }
        return result;
    };

    const editPaymentRequest = async () => {
        const result = await paymentHk.update(payment);
        if (result) {
            clearInputs();
            alert("Updated");
        }
        else {
            //TODO: alert
            alert("Failed");
        }
        return result;
    };

    const handleInputChange = (e) => {
        setPayment({
            ...payment,
            [e.target.name]: e.target.value
        });
    };

    const clearInputs = () => {
        setPayment({
            name: "",
            description: "",
            sys_protected: false,
            active: true
        });
    }

    return (
        <MainPageComponent requireAuthentication={true} path={breadcrumbPath}>
            <CenterCenterVerticalContainer>
                <h1>{props.title}</h1>

                <div className="d-flex flex-column flex-grow-1" style={{ maxWidth: '25rem' }} >
                    <h2>Método de pago</h2>
                    <Form onSubmit={onSubmitForm} className=" border rounded p-3">
                        <FormGroup>
                            <Label for="name">Nombre</Label>
                            <Input id="name" name="name" placeholder="" type="text" required value={payment.name} onChange={handleInputChange} />
                        </FormGroup>
                        <FormGroup>
                            <Label for="description">Descripcion</Label>
                            <Input id="description" name="description" placeholder="" type="text" required value={payment.description} onChange={handleInputChange} />
                        </FormGroup>
                        <div className="d-flex flex-column">
                            <Button>{isEditAction() ? 'Guardar cambios' : 'Crear'}</Button>
                        </div>
                    </Form>
                </div>
            </CenterCenterVerticalContainer>
        </MainPageComponent>
    );
}

export default UserPaymentsCreateView;